/** biome-ignore-all lint/security/noSecrets: vimeo hash */
import "./VideoModal.css";

const VideoModal = ({ videoId, isOpen, onClose }) => {
  if (!isOpen) return null;
  console.log("Opening video modal with video ID:", videoId);

  return (
    <div className="modal">
      <div className="modal__content">
        {/* TODO: Replace with actual video player component and pass videoId as prop
        TODO: Move close button and styling
        Have the modal theme match the rest of the site */}
        <button type="button" className="modal__close" onClick={onClose}>
          ✕
        </button>
        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          {videoId === "commercial" ? (
            <iframe
              src="https://player.vimeo.com/video/1188171515?h=c1fc6e9bae&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;muted=1&quality=1080p"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ELYA DIRECTOR REEL - COMMERCIAL"
            ></iframe>
          ) : (
            <DynamicFrame videoId={videoId} />
          )}
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
    </div>
  );
};

const DynamicFrame = ({ videoId }) => {
  switch (videoId) {
    case "drama":
      return (
        <iframe
          src="https://player.vimeo.com/video/1188498328?h=74748900c8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title="Director's Drama Reel - Elya R."
        ></iframe>
      );
    case "corporate":
      return (
        <iframe
          src="https://player.vimeo.com/video/1198782314?h=22d112c3db&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title="Boutique Térébenthine - codirected by Elya R. | image by Elkana R."
        ></iframe>
      );
    case "doc":
      return (
        <iframe
          src="https://player.vimeo.com/video/1198783272?h=92ce4a0b8e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title="Documentary clips - &quot;Prison is Cool&quot; by Elya R."
        ></iframe>
      );
    default:
      return null;
  }
};

export default VideoModal;
export { DynamicFrame };
